import { Overlay, OverlayStyle } from "../../shared/overlay";
import { App } from "./app";
import { Api } from "./api";
import { ApiAttribute, ApiUpdate, ApiConnection } from "./api_data";
import { timeAgoDateFormat } from "../../shared/date_format";
import { div } from "../../shared/dom";
import { VizSVG } from "./viz_svg";
import { TableConnection, DataConnection, Display } from "./display";
import uuid = require("uuid");
import { Editor } from "./editor";
import { BQ } from "./bq";
import { Page } from "./page";
import { Graph } from "../../shared/graph";

export class TablePicker {

  static render_overlay(page: Page, viz: Display, selected_table: TableConnection | null) {
    const table_picker = div("table-picker");

    const search_input = App.input("search");
    search_input.placeholder = "Search";
    table_picker.appendChild(search_input);

    const list = div("table-picker-list");
    table_picker.appendChild(list);

    const render_list = function (search: string) {
      list.innerHTML = "";
      if (App.table_sets[App.selected_owner_id] === undefined) {
        return;
      }

      for (const table of App.table_sets[App.selected_owner_id]) {
        if (search !== "") {
          const match = table.id.toLowerCase().indexOf(search.toLowerCase()) === 0;
          if (!match) {
            continue;
          }
        }
        const t = div("data-link");
        if (selected_table && selected_table.table.id === table.id) {
          t.classList.add("disabled");
        }
        t.innerText = table.id;
        t.appendChild(VizSVG.large_table_icon());
        const count = div("count");
        count.innerText = Graph.compact_number(table.row_count);
        t.appendChild(count);
        const label = div("meta");
        const date = new Date(table.creation_time);
        label.innerText = timeAgoDateFormat(date);
        t.appendChild(label);
        list.appendChild(t);
        t.onclick = function () {
          if (selected_table && selected_table.table.id === table.id) {
            return;
          }

          const update: ApiUpdate = {
            attributes: [],
            connections: [],
          }
          // remove group by
          viz.group_by = null;
          viz.group_by_interval = null;

          const g_attr: ApiAttribute = {
            parent: viz.id,
            key: "group_by",
            text: null,
            number: null,
          }
          const int_attr: ApiAttribute = {
            parent: viz.id,
            key: "group_by_interval",
            text: null,
            number: null,
          }
          update.attributes.push(g_attr);
          update.attributes.push(int_attr);

          // remove existing conns
          if (viz.selected_table) {
            const del_conn: ApiConnection = {
              id: viz.selected_table.id,
              parent: viz.id,
              key: "table",
              child: viz.selected_table.table.id,
              deleted: true,
            }
            update.connections.push(del_conn);

            for (const s of viz.selected_columns) {
              const c: ApiConnection = {
                id: s.id,
                parent: viz.id,
                key: "column",
                child: s.data.column_name,
                deleted: true,
              }
              update.connections.push(c);
            }
          }

          const conn: TableConnection = {
            viz_id: viz.id,
            id: uuid(),
            table: table,
            closed: false,
          }
          viz.selected_table = conn;
          const api_conn: ApiConnection = {
            id: conn.id,
            parent: viz.id,
            key: "table",
            child: table.id,
            deleted: false,
          }
          update.connections.push(api_conn);

          // add column conns
          viz.selected_columns = [];

          // just the first number and date columns visible
          const visible_cols: string[] = [];
          let numeric_col_found = false;
          let date_col_found = false;
          let sort_col: string | null = null;

          if (table.columns) {
            for (const col of table.columns) {
              if (!numeric_col_found && BQ.numeric_col(col.type)) {
                numeric_col_found = true;
                visible_cols.push(col.name);
              }
              if (!date_col_found && BQ.date_col(col.type)) {
                date_col_found = true;
                visible_cols.push(col.name);
                sort_col = col.name;
              }
            }

            if (!sort_col && table.columns.length > 0) {
              sort_col = table.columns[0].name;
            }
          }

          if (numeric_col_found) {
            viz.count.hidden = true;
            const count: ApiAttribute = {
              parent: viz.id,
              key: "count_hidden",
              text: null,
              number: 1,
            };
            update.attributes.push(count);
          }

          if (sort_col) {
            viz.sort = sort_col;
            viz.sort_order = Editor.sort_orders[0].value;
            const sort: ApiAttribute = {
              parent: viz.id,
              key: "sort",
              text: sort_col,
              number: null,
            };
            const order: ApiAttribute = {
              parent: viz.id,
              key: "sort_order",
              text: Editor.sort_orders[0].value,
              number: null,
            };
            update.attributes.push(sort);
            update.attributes.push(order);
          }

          if (table.columns) {
            if (visible_cols.length === 0 && table.columns.length > 0) {
              visible_cols.push(table.columns[0].name);
            }

            for (let i = 0; i < table.columns.length; i++) {
              const col = table.columns[i];
              const data = Editor.column_selection_data(viz.id, conn, col, i);
              const c: DataConnection = {
                viz_id: viz.id,
                id: data.connection_id,
                data: data.col_data,
                position: i,
              }

              if (!visible_cols.includes(col.name)) {
                const attr: ApiAttribute = {
                  parent: c.id,
                  key: "hidden",
                  text: null,
                  number: 1,
                }
                c.data.hidden = true;
                update.attributes.push(attr);
              }

              viz.selected_columns.push(c);

              update.attributes = update.attributes.concat(data.attributes);
              update.connections = update.connections.concat(data.connections);

              if (App.user && col.name === visible_cols[0]) {
                const id = conn.id + ":" + data.connection_id;
                const selection_attr: ApiAttribute = {
                  parent: App.user.id,
                  key: "selected_element",
                  text: id,
                  number: null,
                }
                update.attributes.push(selection_attr);
                page.selected_element = id;
              }
            }
          }

          Api.update_display(viz.id, update);
          viz.query_columns = [];
          App.render();
          Overlay.close();

        }
      }
    }
    render_list("");

    search_input.oninput = function () {
      render_list(search_input.value);
    }

    const overlay = new Overlay(OverlayStyle.Viz, "Select Table", [table_picker], "", function () {
      //
    }, undefined, function () {
      search_input.focus();
    });
    overlay.panel.classList.add("overlay-table-picker");

  }

}